import { Gulp } from "@types/gulp";
import * as VinylFile from "@types/vinyl";
import * as dateFormat from "dateformat";
import * as del from "del";
import * as fs from "fs";
import * as merge from "merge2";
import * as path from "path";
// tslint:disable-next-line:no-var-requires
const npmUtils: { pack: (options: any) => Promise<string> } = require("npm-utils");
// tslint:disable-next-line:max-line-length no-var-requires
const tap: (callback: (file: VinylFile) => any) => NodeJS.ReadWriteStream = require("gulp-tap");
// tslint:disable-next-line:no-var-requires
const nugetpack = require("gulp-nuget-pack");
interface IPackageJson {
    main: string;
    version: string;
    author?: string;
    description?: string;
    keywords?: string[];
}
interface IOptions {
    additionalNpmFiles?: string;
}

module.exports = (parentGulp?: Gulp, options?: IOptions): void => {
    const standalone = !parentGulp;
    const gulp: Gulp = parentGulp || require("gulp");

    const packageInfo: IPackageJson = require(path.join(process.cwd(), "package.json"));
    const patch = dateFormat(new Date(), "UTC:yymmddHH");
    packageInfo.version = packageInfo.version.replace(/^(\d+\.\d+)(\.\d+)?$/, `$1.${patch}`);
    const extraTags: string[] = [];
    for (let ix = 0; ix < process.argv.length - 1; ++ix) {
        if (process.argv[ix].match(/^--?(Label|Tag)$/)) {
            extraTags.push(process.argv[++ix]);
        }
    }
    packageInfo.keywords = (packageInfo.keywords || []).concat(extraTags || []);
    const noNpmIndex = packageInfo.keywords.indexOf("NoNpm");
    if (noNpmIndex > -1) {
        packageInfo.keywords.splice(noNpmIndex, 1);
    }

    gulp.task("clean:npm", () => {
        return del(["npm", "dist/npm-tarball.tgz"]);
    });

    gulp.task("clean:nuget", () => {
        return del(["dist/*.nupkg"]);
    });

    gulp.task("prepare:npm", ["clean:npm"], () => {
        const npmMainJs = packageInfo.main || "NO_MAIN.js";
        return gulp.src([
            "./README.md",
            `./dist/${npmMainJs}`,
            `./dist/${npmMainJs}.map`,
            `./dist/${npmMainJs.replace(/.js$/, ".d.ts")}`,
            "./style/**/*.less",
            "./tests/*Mocks.d.ts",
            "./tests/*Mocks.js",
            "./typings.json ",
        ].concat(options && options.additionalNpmFiles ? options.additionalNpmFiles : [])).
            pipe(gulp.dest("./npm/"));
    });

    gulp.task("prepare:nuget", ["clean:nuget"], () => { /* empty */ });

    gulp.task("pack:npm", ["prepare:npm"], () => {
        if (noNpmIndex > -1) {
            return new Promise((resolve) => { resolve(); });
        }
        const packageJSON = JSON.stringify(packageInfo);
        fs.writeFileSync("./npm/package.json", packageJSON);
        return npmUtils.pack({ folder: "./npm/" }).then((name: string) => {
            if (!fs.existsSync("dist")) {
                fs.mkdirSync("dist");
            }
            return fs.rename(name, "dist/npm-tarball.tgz", () => { /* empty */ });
        });
    });

    gulp.task("pack:nuget", ["prepare:nuget"], () => {
        return merge([
            // Old IA config.js format
            gulp.src("./nuget/**/config.js").
                pipe(tap((file) => {
                    const config = require(file.path)(packageInfo, extraTags ? extraTags.join(" ") : null);
                    return new Promise((resolve) => nugetpack(config.options, config.files, () => {
                        resolve();
                    }));
                })),
            // config.json format
            gulp.src(["./**/*nuspec.json", "!./Tests/**"]).
                pipe(tap((file) => {
                    const config = require(file.path);
                    const dirname = path.dirname(file.path);
                    config.options.version = config.options.version ?
                        config.options.version.replace(/^(\d+\.\d+)(\.\d+)?$/, `$1.${patch}`) :
                        packageInfo.version;
                    config.options.title = config.options.title || config.options.id;
                    config.options.authors = config.options.authors || packageInfo.author;
                    config.options.owners = config.options.owners || "ProActive A/S";
                    config.options.copyright = config.options.copyright || "ProActive A/S";
                    if (fs.existsSync(path.join(dirname, "description.md"))) {
                        config.options.description = fs.readFileSync(path.join(dirname, "description.md"), "utf8");
                    } else {
                        config.options.description = fs.readFileSync("./README.md", "utf8");
                    }
                    config.options.summary = config.options.summary || packageInfo.description;
                    config.options.releaseNotes = fs.readFileSync(path.join(dirname, "releasenotes.md"), "utf8");
                    config.options.tags = config.options.tags ?
                        [config.options.tags].concat(extraTags || []).join(" ") :
                        (packageInfo.keywords || []).join(" ");
                    config.options.requireLicenseAcceptance = config.options.requireLicenseAcceptance || false;
                    config.options.outputDir = "./dist/";
                    config.files = config.files || [
                        {
                            dest: "/content/",
                            src: path.join(dirname, "content", "*"),
                        },
                        {
                            dest: "/deployment/",
                            src: path.join(dirname, "deployment", "*"),
                        },
                        {
                            dest: "/tools/",
                            src: path.join(dirname, "tools", "*"),
                        },
                    ];
                    return new Promise((resolve) => nugetpack(config.options, config.files, () => {
                        resolve();
                    }));
                })),
        ]);
    });

    gulp.task("pack:all", ["pack:npm", "pack:nuget"]);

    if (standalone) {
        gulp.task("default", ["pack:all"]);
    }
};
